export default {
  methods: {
    InitBackgroundColor(ref, color = '#f8f8f8') {
      if(ref && ref.style) {
        ref.style.backgroundColor = color
      }
    },
    InitMinHeight(refs) {
      if (Array.isArray(refs)) {
        for(let i in refs) {
          if(refs[i] && refs[i].style) {
            refs[i].style.minHeight = window.innerHeight + "px"
          }
        }
      } else {
        if(refs && refs.style) {
          refs.style.minHeight = window.innerHeight + "px"
        }
      }
    },
    InitMinHeightPaging(refs) {
      if (Array.isArray(refs)) {
        for(let i in refs) {
          if(refs[i] && refs[i].style) {
            refs[i].style.minHeight = window.innerHeight - 50 + "px"
          }
        }
      } else {
        if(refs && refs.style) {
          refs.style.minHeight = window.innerHeight - 50  + "px"
        }
      }
    },
    InitHeight(refs) {
      if (Array.isArray(refs)) {
        for(let i in refs) {
          if(refs[i] && refs[i].style) {
            refs[i].style.height = window.innerHeight + "px"
          }
        }
      } else {
        if(refs && refs.style) {
          refs.style.height = window.innerHeight + "px"
        }
      }
    },
    InitMaxWidth(ref) {
      (function (doc, win, undefined) {
        var docEl = doc.documentElement,
          recalc = function () {
            var clientWidth = docEl.clientWidth;
            if(clientWidth < 600) return;
            clientWidth = 600;
            if (clientWidth === undefined) return;
            ref.style.maxWidth = clientWidth + "px"
            ref.style.margin ='0 auto';
            docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
          };
        recalc();
      })(document, window);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/initStyle.js